import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ContextService } from './services/context/context.service';

/**
 *  Parses the url in the browser to detect the current environment (local, e, k, p)
 *  to call the corresponding rest-interface.
 */
@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private readonly contextService = inject(ContextService);

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const baseUrl = this.contextService.getBaseUrl(req.url);
    const apiReq = req.clone({ url: `${baseUrl.toString()}${req.url}` });
    return next.handle(apiReq);
  }
}
